import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaTimes, FaHome, FaPhone } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);


  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <div className="logo-icon">
            <FaHome />
          </div>
          <div className="logo-text">
            <span className="logo-name">Casa Bonita</span>
            <span className="logo-subtitle">Bienes Raíces</span>
          </div>
        </Link>

        {/* Links desktop */}
        <ul className={`navbar-links ${isOpen ? 'navbar-links--open' : ''}`}>
          <li>
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''} onClick={closeMenu}>
              Inicio
            </NavLink>
          </li>
          <li>
            <NavLink to="/propiedades" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeMenu}>
              Propiedades
            </NavLink>
          </li>
          <li>
            <NavLink to="/contacto" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeMenu}>
              Contacto
            </NavLink>
          </li>
          <li className="navbar-cta">
            <a href="tel:+16474700762" className="btn-call" onClick={closeMenu}>
              <FaPhone /> Llamar
            </a>
          </li>
        </ul>

        {/* Hamburger */}
        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Overlay mobile */}
      {isOpen && <div className="navbar-overlay" onClick={closeMenu} />}
    </nav>
  );
};

export default Navbar;
